import { signal } from "@lit-labs/signals";
import { ColorScheme } from "@pentacode/core";

export function loadClientColorScheme(): ColorScheme {
    return (localStorage.getItem("color-scheme") as ColorScheme) || "system";
}

export const appColorScheme = signal(loadClientColorScheme());
